// extracted by mini-css-extract-plugin
export default {"body":"BodyJson_body__7n2Sv","childStyle":"BodyJson_childStyle__+8nFR"};